import axios from "axios";

export async function uploadDesignFileToDashboard(params: {
	fileType: "xml" | "dxf";
	fileData: string;
	fileName: string;
	siteId: string;
}): Promise<void> {
	const { fileType, fileData, fileName, siteId } = params;
	try {
		await axios.post(
			`${import.meta.env.VITE_API_BASE}/dashboard/designFile`,
			{
				fileType,
				[`${fileType}Data`]: fileData,
				[`${fileType}Name`]: fileName,
				siteId,
			},
			{ headers: { "Content-Type": "application/json" } },
		);
	} catch (e) {
		throw new Error(`Failed to upload design file to dashboard: ${e}`);
	}
}
